<template>
  <div class="footer">
    <div class="ft-layout">
      <div class="foot-main">
        <div class="foot-logo">
          <div class="logo-img" @click="gotoHome">
            <!-- <img @click="gotoHome" src="../assets/logo_sm.png" /> -->
            <!-- <svg class="p-icon" aria-hidden="true">
              <use href="#iconziyuan21"></use>
            </svg> -->
            <img src="../assets/logo.png" />
          </div>
          <div class="line">商务合作：service@dll-dtech.com</div>
          <div class="line">公司地点：湖南省长沙市天心区芙蓉中路二段116-1号众东国际2704</div>
        </div>

        <div class="foot-txt">
          <!-- <div class="item">
            <div class="name">产品</div>
            <div class="product" v-for="item in navList" :key="item.index">
              <div class="line" @click="goProduct(item.index)">
                {{ item.name }}
              </div>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="name">关于我们</div>
            <router-link :to="{ path: '/about' }" class="line"
              >公司简介</router-link
            >
            <router-link :to="{ path: '/join' }" class="line"
              >加入我们</router-link
            >
            <router-link :to="{ path: '/about' }" class="line"
              >最新动态</router-link
            >
          </div> -->
        </div>

        <!-- <div class="foot-share">
          <div class="name">关注我们</div>
          <div class="wechat">
            <img src="../assets/home_ bot_dy.png" />
            <div class="txt">打开抖音扫一扫</div>
          </div>
          <div class="wechat">
            <img src="../assets/home_ bot_wx.png" />
            <div class="txt">打开微信扫一扫</div>
          </div>
        </div> -->
      </div>
      <!-- <div  style="width: 300px; margin: 0px auto; padding: 20px 0px;">
        <a  target="_blank" 
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010302001605" 
          style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px;">
          <img data-v-945c91b8="" src="../assets//gonganbeian.png" style="float: left; width: 18px; height: 18px;">
          <p data-v-945c91b8="" style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: rgb(147, 147, 147);">湘公网安备 43010302001605号</p>
        </a>
      </div> -->

      <div class="copyright">
        <a  target="_blank" 
        href="https://beian.miit.gov.cn/" style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px; color: rgb(147, 147, 147);">©Copyright 2024 德礼来 湘ICP备2024071364号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      number: -1,
      formFoot: true,
      navList: [
        {
          index: 0,
          name: "产业金融平台",
          goPath: "product",
          current: 0
        }
      ]
    };
  },
  methods: {
    gotoHome() {
      this.$router.push("/home");
    },
    goProduct(value) {
      this.$store.commit("setProductIndex", { index: value }); //更新点击的产品索引值
      this.number = -1;
      if (this.number !== value) {
        this.number = value;
        this.$router.push({
          name: this.navList[value].goPath,
          params: {
            current: this.navList[value].current,
            type: 1
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.footer {
  color: #fff;
  font-size: 16px;
  line-height: 35px;
  background-color: #222;
}
.ft-layout {
  margin: 0 auto;
  width: 1300px;
}
.foot-main {
  position: relative;
  padding: 40px 0;
  overflow: hidden;
}
.foot-txt {
  float: left;
  position: relative;
  overflow: hidden;
  &:after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 30px;
    width: 1px;
    background-color: rgba(255, 255, 255, 0.4);
  }
  .item {
    float: left;
    margin-right: 90px;
  }
  .name {
    font-size: 20px;
  }
  .line {
    display: block;
    font-size: 16px;
    color: #999;
    text-decoration: none;
    cursor: pointer;
  }
  .wechat {
    margin-top: 8px;
    width: 70px;
    height: 70px;
    img {
      width: 100%;
    }
  }
}
.foot-share {
  float: right;
  margin-right: 30px;
  text-align: center;
  overflow: hidden;
  .name {
    font-size: 20px;
  }
  .wechat {
    float: left;
    margin: 8px 19px;
    width: 110px;
  }
  img {
    width: 110px;
    height: 110px;
  }
  .txt {
    font-size: 14px;
    color: #999;
  }
}
.foot-logo {
  float: left;
  margin: 0 95px 0 50px;
  .logo-img {
    margin-bottom: 10px;
    width: 188px;
  }
  .p-icon {
    width: 188px;
    height: 28px;
  }
  img {
    display: block;
    margin: 10px 0 20px 0;
    width: 100%;
  }
}
.copyright {
  padding: 25px 0 30px 0;
  font-size: 14px;
  color: #fefefe;
  text-align: center;
  line-height: 22px;
  border-top: 1px solid #999;
}
</style>
